module.exports = __webpack_public_path__ + "static/media/texture (9).09ea947d.jpg";